export default {
  tooltips: {
    metrics: {
      online: 'Запрашивать метрики с сервера раз в 15 секунд'
    }
  }
}
